<template>
  <div class="dealer-header">
    <div class="dealer-header__name">{{ name || '—' }}</div>
    <div v-if="hqid" class="dealer-header__hqid">HQID: {{ hqid }}</div>
  </div>
</template>
<script>
export default {
  name: 'DealerDialogHeader',
  props: {
    name: {
      type: String,
      default: ''
    },
    hqid: {
      type: [String, Number],
      default: ''
    }
  }
}
</script>
